import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectDatabaseState = (state: RootState) => state.databaseState;

export const selectStores = createSelector(
  selectDatabaseState,
  (state) => state.dataStore
);

export const selectLocalStores = createSelector(selectDatabaseState, (state) =>
  state.dataStore.filter((store) => store.metadata.type === "local")
);

export const selectOpenAIStores = createSelector(selectDatabaseState, (state) =>
  state.dataStore.filter((store) => store.metadata.type === "openai")
);

export const selectSelectedStore = createSelector(
  selectDatabaseState,
  (state) => state.selectedStore
);

export const selectFileList = createSelector(
  selectDatabaseState,
  (state) => state.fileList
);

export const selectLoading = createSelector(
  selectDatabaseState,
  (state) => state.isStoreLoading
);

export const selectFileLoading = createSelector(
  selectDatabaseState,
  (state) => state.isFileLoading
);

export const selectFileUpload = createSelector(
  selectDatabaseState,
  (state) => state.isFileUpload
);

export const selectMode = createSelector(
  selectDatabaseState,
  (state) => state.mode
);

export const selectStoreType = createSelector(
  selectDatabaseState,
  (state) => state.storeType
);
